var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRecepcionConfirmada = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8574 19.0589H14.8574V6.11774H20.9146C21.4289 6.11774 21.8289 6.47068 22.0003 6.94127L24.0003 13.1766V17.8825C24.0003 18.5295 23.486 19.0589 22.8574 19.0589Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19H1.15385C0.519231 19 0 18.5345 0 17.9655V5.03448C0 4.46552 0.519231 4 1.15385 4H13.8462C14.4808 4 15 4.46552 15 5.03448V19Z",
    fill: "#17CF63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4284 22C21.0064 22 22.2856 20.6832 22.2856 19.0588C22.2856 17.4344 21.0064 16.1176 19.4284 16.1176C17.8505 16.1176 16.5713 17.4344 16.5713 19.0588C16.5713 20.6832 17.8505 22 19.4284 22Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71456 22C7.29252 22 8.57171 20.6832 8.57171 19.0588C8.57171 17.4344 7.29252 16.1176 5.71456 16.1176C4.13661 16.1176 2.85742 17.4344 2.85742 19.0588C2.85742 20.6832 4.13661 22 5.71456 22Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4287 20.2354C20.0599 20.2354 20.5716 19.7087 20.5716 19.0589C20.5716 18.4092 20.0599 17.8824 19.4287 17.8824C18.7976 17.8824 18.2859 18.4092 18.2859 19.0589C18.2859 19.7087 18.7976 20.2354 19.4287 20.2354Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71415 20.2354C6.34533 20.2354 6.857 19.7087 6.857 19.0589C6.857 18.4092 6.34533 17.8824 5.71415 17.8824C5.08296 17.8824 4.57129 18.4092 4.57129 19.0589C4.57129 19.7087 5.08296 20.2354 5.71415 20.2354Z",
    fill: "#78909C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7145 12.5883H17.7145C17.3716 12.5883 17.1431 12.353 17.1431 12V7.88236C17.1431 7.52942 17.3716 7.29413 17.7145 7.29413H20.7431C20.9716 7.29413 21.2002 7.4706 21.2574 7.70589L22.2288 10.7647C22.2288 10.8235 22.2859 10.8824 22.2859 10.9412V12C22.2859 12.353 22.0574 12.5883 21.7145 12.5883Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0375 8.00012L6.58125 11.558L4.9625 9.84663L4 10.8374L6.58125 13.4946L11 8.94589L10.0375 8.00012Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRecepcionConfirmada, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RecepcionConfirmada.0110e504.svg";
export { ForwardRef as ReactComponent };